<app-banner [heading]="'FEE STRUCTURE'" [detail]="'SESSION 2024-25'"></app-banner>

<main id="main">
    <section class="about" id="about">
    <div class="container">
    <div class="row">
    <div class="col-lg-12 col-md-6">
    <p class="heading2"><!-- ======= Table Section ======= --></p>
    
    <h2>No Annual Fee for any class</h2>
    
    <table class="table table-hover">
        <thead>
            <tr>
                <th width="25%">Grade</th>
                <th scope="25%">Admission Fee</th>
                <th scope="25">Tuition Fee</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">Pre-Nursery</th>
                <td>7,000/-</td>
                <td>2,050/-</td>
            </tr>
            <tr>
                <th scope="row">Nursery to U.K.G.</th>
                <td>12,000</td>
                <td>3,600/-</td>
            </tr>
            <tr>
                <th scope="row">I to V</th>
                <td>18,000/-</td>
                <td>4,600/-</td>
            </tr>
            <tr>
                <th scope="row">VI to VIII</th>
                <td>20,000/-</td>
                <td>4,800/-</td>
            </tr>
            <tr>
                <th scope="row">IX to X</th>
                <td>20,000/-</td>
                <td>5,100/-</td>
            </tr>
            <tr>
                <th scope="row">XI</th>
                <td>20,000/-</td>
                <td>5,300/-</td>
            </tr>
            
        </tbody>
    </table>
    
    <hr>
    <h2><b>Documents required for admission.</b></h2>
    
    <ol>
        <li>Student's Aadhar Card</li>
        <li>Parent's Aadhar Card</li>
        <li>Date of Birth certificate of child</li>
        <li>Photographs :- 1. with parents, 1 in school uniform (thumbnail size), 2 passport size</li>
        <li>Previous class report card (Xerox)</li>
        <li>Onlne S.L.C. ( School leaving certificate) from last school</li>
    </ol>
    <!-- ======= Table Section ======= --></div>
    </div>
    </div>
    </section>
    <!-- End About Section --><!-- ======= About Section ======= --></main>